const OPEN_PART_STATUSES = [
  {
    value: "Delayed - Availability",
    label: "Delayed - Availability",
    id: "Delayed - Availability",
    name: "Delayed - Availability",
    checked: false,
  },
  {
    value: "Delayed - Backordered",
    label: "Delayed - Backordered",
    id: "Delayed - Backordered",
    name: "Delayed - Backordered",
    checked: false,
  },
  {
    value: "Delayed - Research",
    label: "Delayed - Research",
    id: "Delayed - Research",
    name: "Delayed - Research",
    checked: false,
  },
  {
    value: "Ordered",
    label: "Ordered",
    id: "Ordered",
    name: "Ordered",
    checked: false,
  },
  {
    value: "Part Requested",
    label: "Part Requested",
    id: "Part Requested",
    name: "Part Requested",
    checked: true,
  },
  {
    value: "Received",
    label: "Received",
    id: "Received",
    name: "Received",
    checked: false,
  },
  {
    value: "Waiting on Vendor",
    label: "Waiting on Vendor",
    id: "Waiting on Vendor",
    name: "Waiting on Vendor",
    checked: false,
  },
];

export default OPEN_PART_STATUSES;
